import{gql as e}from"graphql-tag";const s=e`
    mutation UpdateMessage($conversationUuid: UUID!, $messageUuid: UUID!, $readAt: DateTime!) {
  updateMessage(
    conversationUuid: $conversationUuid
    messageUuid: $messageUuid
    readAt: $readAt
  ) {
    ok
  }
}
    `;export{s as UpdateMessageDocument};
//# sourceMappingURL=updateMessageMutation.generated.es.js.map
